// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aPBb","icon":"styles_icon__3gPLt"};